<script lang="ts">

    import { onMount } from "svelte";

    export let props = {
        isDisplayed: false,
        message: ""
    }

    let show_popup: boolean = false;
	
    onMount(async () => {
        if (props.isDisplayed) {
            launch_popup();
        }
    });

    function launch_popup() {
        show_popup = true;
        setTimeout(function(){ show_popup = false; }, 2000);
    }

</script>

<style lang="scss">

    .popup {
        display: none;
        width: 50px;
        height: 50px;
        margin: auto;
        background-color: #333;
        color: #fff;
        text-align: center;
        border-radius: 2px;
        z-index: 1;
        font-size: 17px;
        white-space: nowrap;
        border-radius: 10px;
        background-color: $color_primary;
        color: $color_white;
        opacity: 0;
        text-align: center;
        padding: 10px;
        &__displayed {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            animation-name: fadein;
            animation-duration: 2s;
            overflow: hidden;
            margin: 4px 4px 4px 4px;
        }
    }

    @keyframes fadein {
        0% {opacity: 0;}
        50% {opacity: 1;}
        100% {opacity: 0;}
    }

</style>

<div class="popup" class:popup__displayed={show_popup}>{props.message}</div>
